var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',[_c('div',{staticClass:"center"},[_c('Header')],1),_c('div',{staticClass:"center",staticStyle:{"width":"1920px"}},[_c('Navigation',{staticStyle:{"width":"100%"}})],1),_c('div',{staticClass:"center"},[_c('router-view')],1),_c('div',{staticClass:"center"},[_c('Bottom')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }